import React from 'react'
import './performance.css'

const PerformanceScore = ({score}) => {
  score = isNaN(score) ? 0 : parseInt(score, 10)
  return (
    <div className='w-full flex gap-4 justify-center items-center mt-6'>
        <div className='flex flex-col justify-center items-center'>
            <div className={`w-[30px] h-[30px] mb-1 result_border_class ${score <= 49 ? 'bg_class_red' : 'bg-trans'}`} />
            <p>Below Expectation</p>
            <p>0% – 49%</p>
        </div>
        
        <div className='flex flex-col justify-center items-center'>
            <div className={`w-[30px] h-[30px] mb-1 result_border_class ${(score >= 50 && score <= 74) ? 'bg_class_orange' : 'bg-trans'}`} />
            <p>Meet Expectation</p>
            <p>50% - 74%</p>
        </div>

        <div className='flex flex-col justify-center items-center'>
            <div className={`w-[30px] h-[30px] mb-1 result_border_class ${score >= 75 ? 'bg_class_green' : 'bg-trans'}`}/>
            <p>Exceed Expectation</p>
            <p>75% - 100%</p>
        </div>
    </div>
  )
}

export default PerformanceScore